module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/chad/Developer/shelfmaid-abel/site/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1